import {
  IClientProfileUpdate,
  IItemWithProduct,
  IPatient,
  UISubscriptionStatus,
} from "common/types";
import { Optional } from "common/utils/types";
import { Destination } from "common/router/types";
import { OnboardingClientEventKind } from "common/types/onboarding";

import { ModalStatus } from "client/common/types";
import { IClient } from "client/accounts/types";

export type ControlledSubstancesRequiredField = Partial<keyof IClientProfileUpdate>;

/** matches onboarding ClientOnboardingSerializer */
export type OnboardingClient = {
  id: number;
  subscriptions: IOnboardingSubscription[];
  controlled_substances_required_fields: ControlledSubstancesRequiredField[];
  has_missing_controlled_substances_required_fields: boolean;
};

/* matches onboarding ClientSubscriptionOnboardingListSerializer */
export type IOnboardingSubscription = {
  id: number;
  item: IItemWithProduct;
  patient: IPatient;
  quantity: number;
  frequency_display: string;
  next_order_date: string;
  visible_status: UISubscriptionStatus;
  visible_status_display: string;
  unit_price: number;
  subtotal: number;
  first_discount_value: number;
  recurring_discount_value: number;
  subtotal_with_first_discount: number;
  subtotal_with_recurring_discount: number;
  client_handling_fees: number;
  client_purchasing_fee: number;
  shipping: Optional<number>;
  total: number;
  payment_method_id: Optional<number>;
};

/** Matches onboarding ClientCreateOnboardingEventSerializer  */
export interface OnboardingEventCreate {
  kind: OnboardingClientEventKind;
}

export type OnboradingSubscriptionsSearch = Record<string, string | boolean | number>;

export enum OnboardingDetailSubscriptionStep {
  QuantityFrequency = "quantity-frequency",
  NextOrderDate = "next-order-date",
  Cancel = "cancel",
  PatientMissingFields = "patient-missing-fields",
}

export enum OnboardingSubscriptionsStep {
  List = "list",
  QuantityFrequency = "quantity-frequency",
  NextOrderDate = "next-order-date",
  Cancel = "cancel",
  Billing = "billing",
  ProfileMissingFields = "profile-missing-fields",
  PatientMissingFields = "patient-missing-fields",
  ControlledSubstances = "controlled-substances",
  Complete = "complete",
}

export type OnboardingSubscriptionsStepParams = {
  id: Optional<number>;
  onNext: () => void;
  // whether the next button should be spinning as it tries to go to the next page
  isLoadingNext: boolean;
  client: IClient;
  onboarding: OnboardingClient;
  subscription: Optional<IOnboardingSubscription>;
  stepper: React.ReactNode;
  rootDest: Destination;
};

export type OnboardingDetailSubscriptionStepParams = OnboardingSubscriptionsStepParams & {
  id: number;
  subscription: IOnboardingSubscription;
};

export type OnboardingSubscriptionDetailParams = {
  id: number;
  step: OnboardingSubscriptionsStep;
};

export type OnboradingSubscriptionListParams = {
  step: OnboardingSubscriptionsStep;
};

export type OnboardingSubscriptionsBillingStepParams = {
  createAddressModalIsVisible: ModalStatus;
  createPaymentModalIsVisible: ModalStatus;
};

export type OnboardingSubscriptionNextOrderDateStepParams = {
  updateNextOrderDateModalIsVisible: ModalStatus;
};

export type OnboardingSubscriptionsErrorSearch = {
  status?: number;
};

/** Matches onboarding OnboardingSubscriptionCancelReason */
export enum OnboardingSubscriptionCancelReason {
  NoLongerNeeded = "NO_LONGER_NEEDED",
  Expensive = "EXPENSIVE",
  SubscriptionNotWanted = "SUBSCRIPTION_NOT_WANTED",
  NoLongerClientOfClinic = "NO_LONGER_CLIENT_OF_CLINIC",
  PatientInactive = "PATIENT_INACTIVE",
  Other = "OTHER",
}

export type OnboardingSubscriptionCancelReasonOption = {
  value: OnboardingSubscriptionCancelReason;
  label: string;
};
